import { LOADED, STATUS_NOT_LOADED } from "../../api/constant";

export const types = {
    CHANGE_INPUT_FILTER_OUTS: "change_input_filter_outs",
    MOVEMENTS_LOADED: "movements_loaded",
};

export const INITIAL_STATE = {

    elements: [],
    status: STATUS_NOT_LOADED,
    filter: {
      name: null,
      reference: null,
      limit: 20,
      page: 1,
    },
    rows: 0,
  
}

export const outIndexReducer = (state, action) => {
    const payload = action.payload;
    const {
      CHANGE_INPUT_FILTER_OUTS,
      MOVEMENTS_LOADED,
      RELOAD_MOVEMENTS_BY_FILTER,

    } = types;

    switch (action.type) {

        case MOVEMENTS_LOADED:
            return {
              ...state,
              elements: payload.elements,
              rows: payload.rows,
              status: LOADED,
            };

    case CHANGE_INPUT_FILTER_OUTS:
        return {
            ...state,
            status: STATUS_NOT_LOADED,
                filter: {
                ...state.filter,
                [payload.name]: payload.value,
                },

        };

        default:
        return state;
    }
}